<!--first display position, render initial route here-->

<div id="app" [class.app-boxed-page]="app.layout.isBoxedPage">
  <router-outlet></router-outlet>
</div>


